import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  routes: [
    { path: "/", redirect: { name: "home" } },
    {
      path: "/home",
      name: "home",
      component: () => import("@/views/home/home.vue")
    },
    {
      path: "/packageDetail",
      name: "packageDetail",
      component: () => import("@/views/packageDetail/packageDetail.vue")
    },
    {
      path: "/redirectPage",
      name: "redirectPage",
      component: () => import("@/views/redirectPage/redirectPage.vue")
    },
    {
      path: "/addDizhi",
      name: "addDizhi",
      component: () => import("@/views/addDizhi/addDizhi.vue")
    },
    {
      path: "/destination",
      name: "destination",
      component: () => import("@/views/home/destination/destination.vue")
    },
    {
      path: "/country",
      name: "country",
      component: () => import("@/views/home/destination/country.vue")
    },
    {
      path: "/orderAddress",
      name: "orderAddress",
      component: () => import("@/views/orderAddress/orderAddress.vue")
    },
    {
      path: "/Cashback",
      name: "Cashback",
      component: () => import("@/views/Cashback/Cashback.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/register",
      name: "register",
      component: () => import("@/views/register/register.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/myOrder",
      name: "myOrder",
      component: () => import("@/views/myOrder/myOrder.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/showList",
      name: "showList",
      component: () => import("@/views/myOrder/showList.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/vip",
      name: "vip",
      component: () => import("@/views/vip/vip.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/edit",
      name: "edit",
      component: () => import("@/views/edit/edit.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/pay",
      name: "pay",
      component: () => import("../views/pay/pay.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/transport",
      name: "transport",
      component: () => import("@/views/transport/transport.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/orderCheck",
      name: "orderCheck",
      component: () => import("@/views/orderCheck/orderCheck.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/my",
      name: "my",
      component: () => import("@/views/my/my.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/fastOrder",
      name: "fastOrder",
      component: () => import("@/views/fastOrder/fastOrder.vue")
    },
    {
      path: "/fastOrder2",
      name: "fastOrder2",
      component: () => import("@/views/fastOrder/fastOrder2.vue")
    },
    {
      path: "/fastOrder3",
      name: "fastOrder3",
      component: () => import("@/views/fastOrder/fastOrder3.vue")
    },
    {
      path: "/shop",
      name: "shop",
      component: () => import("@/views/shop/shop.vue")
    },
    {
      path: "/modifyPass",
      name: "modifyPass",
      component: () => import("@/views/setUp/modifyPass.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/setUp",
      name: "setUp",
      component: () => import("@/views/setUp/setUp.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/priceCheck",
      name: "priceCheck",
      component: () => import("@/views/priceCheck/priceCheck.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/InviteFriends",
      name: "InviteFriends",
      component: () => import("@/views/InviteFriends/InviteFriends.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/checkCountry",
      name: "checkCountry",
      component: () =>
        import("@/views/priceCheck/checkCountry/checkCountry.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/login/login.vue")
    },
    {
      path: "/zhuce",
      name: "zhuce",
      component: () => import("@/views/login/zhuce/zhuce.vue")
    },
    {
      path: "/payoff",
      name: "payoff",
      component: () => import("@/views/payoff/payoff.vue")
    },
    {
      path: "/invitation",
      name: "invitation",
      component: () => import("@/views/invitation/invitation.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/Rebate",
      name: "Rebate",
      component: () => import("@/views/Rebate/Rebate.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/coupons",
      name: "coupons",
      component: () => import("@/views/coupons/coupons.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/useDetails",
      name: "useDetails",
      component: () => import("@/views/useDetails/useDetails.vue")
    },
    {
      path: "/recharge",
      name: "recharge",
      component: () => import("@/views/recharge/recharge.vue")
    },
    {
      path: "/address",
      name: "address",
      component: () => import("@/views/address/address.vue")
    },
    {
      path: "/addAddress",
      name: "addAddress",
      component: () => import("@/views/addAddress/addAddress.vue")
    },
    {
      path: "/saveAddress",
      name: "saveAddress",
      component: () => import("@/views/addAddress/saveAddress.vue")
    },
    {
      path: "/logistics",
      name: "logistics",
      component: () => import("@/views/logistics/logistics.vue")
    },
    {
      path: "/mylist",
      name: "mylist",
      component: () => import("@/views/address/mylist.vue")
    },
    {
      path: "/declaration",
      name: "declaration",
      component: () => import("@/views/address/declaration.vue")
    },
    {
      path: "/Mdeclaration",
      name: "Mdeclaration",
      component: () => import("@/views/address/Mdeclaration.vue")
    },
    {
      path: "/searchList",
      name: "searchList",
      component: () => import("@/views/searchList/searchList.vue")
    }
  ]
});
